import React from 'react';
import { Form, Input, Select, Row, Col } from 'antd';

import {useDispatch, useSelector} from 'react-redux';
import { atualizaProduto } from '../store/cadastro-produto.reducer';
import { InputNumero } from '../../../Numeros/input-numero';
import { newProduto } from '../store/produto.domain';


const TabDados = ({form, dataTab="dados"}) => {
    
    const { Option } = Select;
     
    
    const dispatch = useDispatch();

    

    const {produto:dadosProduto} = useSelector(state => state.produto);
    const produto = newProduto(dadosProduto);
    
    const changeValorCustoHandler = ({floatValue})=> {
       produto.fillValorCusto(floatValue);
        dispatch(atualizaProduto(produto.toPlainJson()));
    }


    const changeVUnComHandler = (value) => {
        const {floatValue:vUnCom} = value;

        produto.fillVUnCom(vUnCom);
        
        
        dispatch(atualizaProduto(produto.toPlainJson()));
    }

    const changeMarkupHandler = ({floatValue}) => {
        produto.fillMarkup(floatValue);
        dispatch(atualizaProduto(produto.toPlainJson()));
    }

    const tipoDesativado = produto.hasId();
    
   
    return (
        <Row gutter={[16, 16]}>
          
                    <Col span={8}>
                        <Form.Item label="Código" name="codigo"  maxLength={60}>
                            <Input  data-tab={dataTab} />
                        </Form.Item>
                    </Col>
                    
                    <Col span={8}>
                        <Form.Item label="Categoria" name="categoria">
                            <Input data-tab={dataTab}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Tipo de Produto" name="tipoProduto" >
                            <Select data-tab={dataTab} disabled={tipoDesativado}>
                                <Option value="SIMPLES">Produto Simples</Option>
                                <Option value="MATERIA_PRIMA">Matéria Prima</Option>
                                <Option value="PRODUTO_COMPOSTO">Produto Composto</Option>
                                <Option value="RODIZIO">RODIZIO</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Valor de Custo" name="valorCusto" >
                            <InputNumero data-tab={dataTab} addonBefore="R$" style={{width: "100%"}} onBlur={changeValorCustoHandler} step={0}  controls={false} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Markup de Entrada" name="markup">
                            <InputNumero data-tab={dataTab} addonAfter="%" onBlur={changeMarkupHandler} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Valor de Venda"  name="vUnCom">
                            <InputNumero data-tab={dataTab} addonBefore="R$"  onBlur={changeVUnComHandler} style={{width: "100%"}} step={0} controls={false} />
                        </Form.Item>
                    </Col>
 
                    <Col span={8}>
                        <Form.Item label="Valor de Imposto sobre venda (%)" name="porcentagemImpostosReais" >
                            <InputNumero data-tab={dataTab} addonAfter="%" style={{width: "100%"}} step={0}  controls={false} />
                        </Form.Item>
                    </Col>
                    
                   
        </Row>
    )
}

export { TabDados }